import { render, staticRenderFns } from "./SBHorizontalScroll.html?vue&type=template&id=e8244ae4&scoped=true&"
import script from "./SBHorizontalScroll.ts?vue&type=script&lang=ts&"
export * from "./SBHorizontalScroll.ts?vue&type=script&lang=ts&"
import style0 from "./SBHorizontalScroll.css?vue&type=style&index=0&id=e8244ae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8244ae4",
  null
  
)

export default component.exports